import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-partners-custom-brand',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './partners-custom-brand.html',
  styleUrl: './partners-custom-brand.scss',
})
export class PartnersCustomBrand {

}
